/**
 * Après FAQ — "Show more questions" toggle.
 */
(function () {
  'use strict';

  document.querySelectorAll('[data-faq-show-more]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var faqSection = btn.closest('.apres-faq');
      if (faqSection) {
        faqSection.classList.add('apres-faq--expanded');
        btn.style.display = 'none';
      }
    });
  });
})();
